import { z } from 'zod'
import { baseSchema, Update } from '../../base'
import { generate } from '../../generate'
import { workflowActionSchema } from './actions'
import { workflowActiveRunPayloadSchema__BC } from './payload/backwards-compat'

export const workflowRunSchema = baseSchema.extend({
  trigger: workflowActiveRunPayloadSchema__BC,
  action: workflowActionSchema,
  metadata: z.record(z.string(), z.any()),
  workflowBlockId: z.string(),
  createdAt: z.string(),
  updatedAt: z.string().nullish(),
  status: z.enum([
    'running',
    'pending', // scheduled
    'stopped', // by the user
    'success',
    'error', // failed
  ]),
  branchId: z.string(),
})

export type WorkflowRun = z.infer<typeof workflowRunSchema>
export type WorkflowRunUpdate = Update<WorkflowRun>

export const workflowRunBaseOps = generate(
  'workflow-run',
  workflowRunSchema.parse
)
